import { gql } from "@apollo/client";

export const REASON_FOR_CANCEL = gql`
  query getReasonsForCancel {
    getReasonsForCancel {
      items {
        title,
        description,
        type,
        typeDescription,
      },
      period,
      fee,
      messages,
    }
  }
`;
